import React from 'react';
import SysfarLogo from '../../../assets/img/sysfar-logo.png';
import styles from './ChatMessageGiven.module.css';

// Texto padrão usado quando não há mensagem configurada (aba Mensagens das
// Configurações). O texto configurado já vem com os placeholders substituídos.
const DEFAULT_MESSAGE =
    'Agradecemos pelo seu contato. Nosso horário de serviço é de segunda a sexta-feira, ' +
    'das 8h às 18h. Sua mensagem é muito importante para nós e será respondida no próximo ' +
    'dia útil a partir das 8h. Obrigado pela compreensão.';

const ChatMessageGiven = ({ message }) => (
    <div className={styles.chatMessageGiven}>
        <img src={SysfarLogo} alt="Sysfar" />
        <h3>Atualmente Estamos Fora do Horário de Serviço</h3>
        <p className={styles.message} style={{ whiteSpace: 'pre-line' }}>
            {message && message.trim() ? message : DEFAULT_MESSAGE}
        </p>
    </div>
);

export default ChatMessageGiven;
